﻿import angular from 'angular';
import '../../../services/media';
import '../../../services/product';

angular.module('folkeuni').component('productCarousel', {
    bindings: {
        productList: '<',
        currentProgramUrl: '@',
        productIds: '@',
        siteId: '@'
    },
    templateUrl: '/shop-dist/templates/product-carousel.html?c=' + window.cacheBurst,
    transclude: false,
    controller: function (Media, Product, $element) {
        const $ctrl = this;
        $ctrl.settings = {
            sizesAtBp: {
                desktop: 2,
                mobile: 1
            }
        };
        $ctrl.sizes = window.matchMedia('(max-width: 768px)').matches ? $ctrl.settings.sizesAtBp.mobile : $ctrl.settings.sizesAtBp.desktop;
        $ctrl.productGroups = [];
        $ctrl.offsetWidth = 0;
        $ctrl.currentIndex = 0;
        $ctrl.hideNav = true;
        $ctrl.container = $element[0].querySelector('.product-carousel__slides');
        $ctrl.touchCoords = {
            touchstartX: 0,
            touchendX: 0
        };
        $ctrl.isValid = false;

        $ctrl.$onInit = function () {
            if ($ctrl.productList != null) {
                $ctrl.isValid = true;
                $ctrl.setup();
            } else if ($ctrl.productIds != null && $ctrl.siteId != null && /^[0-9,.]*$/.test($ctrl.productIds)) {
                $ctrl.isValid = true;
                $ctrl.setupByIds();
            }
        }

        $ctrl.setupByIds = function() {
            var currentProductIds = $ctrl.productIds.split(',');
            var validatedProductIds = [];

            for (var i = 0; i < currentProductIds.length; i++) {
                var currentProductId = currentProductIds[i];
                if (!isNaN(parseInt(currentProductId))) {
                    validatedProductIds.push(currentProductId);
                }
            }

            Product.getProductsById($ctrl.siteId, validatedProductIds).then(function (productArray) {
                $ctrl.productList = productArray;
                $ctrl.setup();
            });
        }

        $ctrl.setup = function () {
            $ctrl.buildGroups();
            $ctrl.offsetWidth = $ctrl.container.offsetWidth;
        }

        $ctrl.$postLink = function () {
            if ($ctrl.isValid) {
                $ctrl.resizeHandler();
                window.addEventListener("resize", function (e) {
                    $ctrl.resizeHandler();
                });
            }
        }

        $ctrl.resizeHandler = function () {
            $ctrl.container.addEventListener('touchstart', function (event) {
                $ctrl.touchCoords.touchstartX = event.changedTouches[0].screenX;
            }, false);

            $ctrl.container.addEventListener('touchend', function (event) {
                $ctrl.touchCoords.touchendX = event.changedTouches[0].screenX;
                $ctrl.navigateSlideIndex($ctrl.touchCoords.touchendX < $ctrl.touchCoords.touchstartX);
            }, false);

            clearTimeout(window.resizeTimer);
            window.resizeTimer = setTimeout(function () {
                $ctrl.offsetWidth = $ctrl.container.offsetWidth;
                $ctrl.sizes = window.matchMedia('(max-width: 768px)').matches ? $ctrl.settings.sizesAtBp.mobile : $ctrl.settings.sizesAtBp.desktop;
                $ctrl.buildGroups();

                $element[0].querySelectorAll('.product-carousel__slide').forEach(elm => {
                    elm.style.minWidth = $ctrl.offsetWidth + 'px';
                });
                $ctrl.updateSlidesOffset();
            }, 250);
        }

        $ctrl.navigateSlideIndex = function (navigateForward) {
            if (navigateForward) {
                $ctrl.currentIndex = $ctrl.currentIndex + 1 > $ctrl.productGroups.length - 1 ? 0 : $ctrl.currentIndex + 1;
            } else {
                $ctrl.currentIndex = $ctrl.currentIndex - 1 < 0 ? $ctrl.productGroups.length - 1 : $ctrl.currentIndex - 1;
            }
            $ctrl.updateSlidesOffset();
        }

        $ctrl.updateSlidesOffset = function () {
            $element[0].querySelector('.product-carousel__slides-rail').style.transform = 'translateX(-' + $ctrl.offsetWidth * $ctrl.currentIndex + 'px)';
        }

        $ctrl.buildGroups = function () {
            $ctrl.productGroups = [];
            
            if ($ctrl.productList && $ctrl.productList.length > 0) {
                let group = [];
                $ctrl.hideNav = $ctrl.productList.length <= $ctrl.sizes;
                $ctrl.productList.forEach((product, key) => {
                    group.push(product);
                    while (key == $ctrl.productList.length - 1 && group.length < $ctrl.sizes) {
                        group.push({});
                    }
                    if (group.length >= $ctrl.sizes) {
                        $ctrl.productGroups.push(group);
                        group = [];
                    }
                });
            }
        }
    }
});